type StatCardProps = {
    value: string;
    label: string;
  };
  
  export const StatCard = ({ value, label }: StatCardProps) => {
    return (
      <div>
        <div className="hidden lg:block">
        <div className="
        
        bg-white
        rounded-[28px]
        shadow-[0px_12px_35px_rgba(0,0,0,0.08)]
        flex flex-col justify-center
        p-5
      ">
  
        <div className="
          text-[40px]
          font-semibold
          text-red-600
          leading-none
          text-center
        ">
          {value}
        </div>
  
        <div className="
          mt-2
          text-[16px]
          text-neutral-500
          font-medium
          text-center
        ">
          {label}
        </div>
  
      </div>
        </div>
        <div className="block lg:hidden">
        <div className="
        w-[183px]
        h-[102px]
        bg-white
        rounded-[28px]
        shadow-[0px_12px_35px_rgba(0,0,0,0.08)]
        flex flex-col justify-center
        px-8
      ">
  
        <div className="
          text-[22px]
          font-semibold
          text-neutral-900
          leading-none
        ">
          {value}
        </div>
  
        <div className="
          mt-2
          text-[12px]
          text-neutral-500
          font-medium
        ">
          {label}
        </div>
  
      </div>
        </div>
      </div>
      
    );
  };